// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3rsWk","additionalInfo":"AgreementModal_additionalInfo__9PZ6E"};